var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDirectDials(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 147,
    height: 172.497,
    viewBox: "0 0 147 172.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_171",
    x: 0,
    y: 25.497,
    width: 147,
    height: 147,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198",
    "data-name": "Rectangle 198",
    width: 72.962,
    height: 78,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_399",
    "data-name": "Group 399",
    transform: "translate(-1010.5 -2975.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371",
    transform: "translate(671 416.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M361.162,128.6l2.3-1.836a2.433,2.433,0,0,0-2.816,1.546,3.911,3.911,0,0,0-2.91.18l4.593,1.668a3.476,3.476,0,0,0-1.163-1.557Z",
    transform: "translate(81.31 2448.929)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M735.046,77.5l2.3-1.836a2.433,2.433,0,0,0-2.816,1.546,3.911,3.911,0,0,0-2.91.18l4.593,1.668A3.476,3.476,0,0,0,735.046,77.5Z",
    transform: "translate(-319.479 2492.157)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367",
    transform: "translate(-564.132 180.631) rotate(-17)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 11.168,
    cy: 22.788,
    rx: 11.168,
    ry: 22.788,
    transform: "translate(174.65 2546.304)",
    fill: "#5d45ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M549.9,218.79c4.473-26.838.045-53.578,0-53.845l-.87.147c.045.265,4.448,26.866,0,53.553Z",
    transform: "translate(-365.109 2387.603)",
    fill: "#f8e602"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 0.883,
    height: 11.453,
    transform: "translate(175.569 2564.97) rotate(-61.858)",
    fill: "#f8e602"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 11.454,
    height: 0.883,
    transform: "translate(186.229 2572.303) rotate(-28.158)",
    fill: "#f8e602"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368",
    transform: "translate(696.433 34.469) rotate(11)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8-2",
    "data-name": "Ellipse 8",
    cx: 9.109,
    cy: 18.587,
    rx: 9.109,
    ry: 18.587,
    transform: "translate(174.65 2546.304)",
    fill: "#5d45ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853-2",
    "data-name": "Path 853",
    d: "M549.735,208.862c3.648-21.889.037-43.7,0-43.917l-.71.12c.037.217,3.628,21.912,0,43.679Z",
    transform: "translate(-366.818 2386.452)",
    fill: "#f8e602"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182-2",
    "data-name": "Rectangle 182",
    width: 0.72,
    height: 9.342,
    transform: "translate(175.399 2561.529) rotate(-61.858)",
    fill: "#f8e602"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183-2",
    "data-name": "Rectangle 183",
    width: 9.342,
    height: 0.72,
    transform: "translate(184.094 2567.51) rotate(-28.158)",
    fill: "#f8e602"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M663.565,209.25l2.3-1.836a2.433,2.433,0,0,0-2.816,1.546,3.911,3.911,0,0,0-2.91.18l4.593,1.668A3.476,3.476,0,0,0,663.565,209.25Z",
    transform: "translate(-242.272 2375.306)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1010.5, 2975)",
    filter: "url(#Rectangle_171)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_171-2",
    "data-name": "Rectangle 171",
    width: 114,
    height: 114,
    rx: 5,
    transform: "translate(16.5 39)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382",
    transform: "translate(1044.519 3032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M354.394,113.476a.846.846,0,0,1-.27-.108.864.864,0,0,1-.27-1.133l1.511-2.843a.738.738,0,0,1,1.044-.306.9.9,0,0,1,.378.63l3.329-.216a.9.9,0,0,1,.36-.522.732.732,0,0,1,1.044.306l1.565,2.951a.864.864,0,0,1-.27,1.133.562.562,0,0,1-.18.09c-.126.846-.72,2.393-2.861,4.8-3.023,3.4-4.84-2.573-5.38-4.786",
    transform: "translate(-299.857 -92.28)",
    fill: "#ffc39c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M357.514,111.353l1.044-1.961a.738.738,0,0,1,1.044-.306.9.9,0,0,1,.378.63l3.329-.216a.894.894,0,0,1,.36-.522.732.732,0,0,1,1.044.306l1.026,1.943a8.038,8.038,0,0,1-4.228,1.188,7.885,7.885,0,0,1-3.994-1.062",
    transform: "translate(-303.049 -92.28)",
    fill: "#fba889",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M345.59,42.989a6.865,6.865,0,0,1-6.855-6.855v-5.9a.837.837,0,0,1,.828-.828.8.8,0,0,1,.63.288c1.493-.666,6.244-2.447,10.994-.144a.866.866,0,0,1,.432-.126.841.841,0,0,1,.846.828v5.884a6.869,6.869,0,0,1-6.873,6.855",
    transform: "translate(-287.131 -24.079)",
    fill: "#ffc39c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M318.418,145.2H291.375a.825.825,0,0,1-.828-.828v-7.629A8.474,8.474,0,0,1,299,128.266h1.6a.882.882,0,0,1,.666.324l3.635,4.822,3.616-4.822a.882.882,0,0,1,.666-.324h1.6a8.474,8.474,0,0,1,8.457,8.475v7.629a.825.825,0,0,1-.828.828",
    transform: "translate(-246.284 -108.725)",
    fill: "#4fba6f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M296.647,202.663h-5.272a.825.825,0,0,1-.828-.828V196.06h6.1Z",
    transform: "translate(-246.284 -166.191)",
    fill: "#ffc39c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M444.163,202.663h-5.272v-6.6h6.1v5.776a.825.825,0,0,1-.828.828",
    transform: "translate(-372.029 -166.191)",
    fill: "#ffc39c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M328.432,193.053h-.918V185.19a.459.459,0,1,1,.918,0Z",
    transform: "translate(-277.619 -156.581)",
    fill: "#49965f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M436.874,193.053h-.936V185.19a.465.465,0,0,1,.468-.468.476.476,0,0,1,.468.468Z",
    transform: "translate(-369.526 -156.581)",
    fill: "#49965f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M334.981,10.688a.832.832,0,0,1-.792-.576,8.166,8.166,0,0,1,3.167-8.8A7.335,7.335,0,0,1,341.513,0a8.376,8.376,0,0,1,4.7,1.493,7.355,7.355,0,0,1,2.609,8.763.833.833,0,0,1-.918.45.861.861,0,0,1-.666-.756c-.27-3.887-3.8-4.354-5.074-4.354-2.735,0-6.316,1.835-6.352,4.264a.816.816,0,0,1-.7.81.307.307,0,0,1-.126.018",
    transform: "translate(-283.035 0)",
    fill: "#24313b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M354.949,69.566h1.336a.27.27,0,0,1,.27.27h0a.27.27,0,0,1-.27.27h-1.336a.27.27,0,0,1-.27-.27h0a.27.27,0,0,1,.27-.27",
    transform: "translate(-300.646 -58.968)",
    fill: "#24313b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M400.893,69.566h1.336a.27.27,0,0,1,.27.27h0a.27.27,0,0,1-.27.27h-1.336a.27.27,0,0,1-.27-.27h0a.27.27,0,0,1,.27-.27",
    transform: "translate(-339.591 -58.968)",
    fill: "#24313b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M358.318,76.652h.006a.479.479,0,0,1,.45.5v.629a.479.479,0,0,1-.45.5h-.006a.479.479,0,0,1-.45-.5v-.629a.479.479,0,0,1,.45-.5",
    transform: "translate(-303.349 -64.975)",
    fill: "#24313b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M357.868,77.635v-.414a.448.448,0,0,1,.378-.45.3.3,0,0,1,.054.18v.45a.281.281,0,0,1-.27.288.22.22,0,0,1-.162-.054",
    transform: "translate(-303.349 -65.075)",
    fill: "#fefefe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M404.144,76.652h.006a.479.479,0,0,1,.45.5v.629a.479.479,0,0,1-.45.5h-.006a.479.479,0,0,1-.45-.5v-.629a.479.479,0,0,1,.45-.5",
    transform: "translate(-342.194 -64.975)",
    fill: "#24313b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M403.7,77.635v-.414a.448.448,0,0,1,.378-.45.23.23,0,0,1,.072.18v.45a.281.281,0,0,1-.27.288h-.018a.291.291,0,0,1-.162-.054",
    transform: "translate(-342.195 -65.075)",
    fill: "#fefefe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M379.9,87.991h.887c.1,0,.18.121.18.27h0c0,.149-.081.27-.18.27H379.9c-.1,0-.18-.121-.18-.27h0c0-.149.081-.27.18-.27",
    transform: "translate(-321.871 -74.586)",
    fill: "#f77f6d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M374.9,101.073a.263.263,0,0,1,.342-.108.257.257,0,0,1,.09.342,1.954,1.954,0,0,1-.756.774,2.068,2.068,0,0,1-2.105,0,1.953,1.953,0,0,1-.756-.774.242.242,0,0,1,.09-.342.237.237,0,0,1,.324.108,1.568,1.568,0,0,0,.594.594,1.5,1.5,0,0,0,.792.216,1.56,1.56,0,0,0,1.385-.81",
    transform: "translate(-315.059 -85.563)",
    fill: "#f77f6d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_194",
    "data-name": "Rectangle 194",
    width: 6.1,
    height: 1.961,
    transform: "translate(66.862 29.869)",
    fill: "#49965f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_195",
    "data-name": "Rectangle 195",
    width: 6.1,
    height: 1.961,
    transform: "translate(44.263 29.869)",
    fill: "#49965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M63.816,113.476a.846.846,0,0,1-.27-.108.889.889,0,0,1-.288-1.133l1.511-2.843a.761.761,0,0,1,1.062-.306.9.9,0,0,1,.378.63l3.329-.216a.761.761,0,0,1,.36-.522.732.732,0,0,1,1.044.306l1.565,2.951a.864.864,0,0,1-.27,1.133.838.838,0,0,1-.18.09c-.126.846-.72,2.393-2.861,4.8-3.023,3.4-4.84-2.573-5.38-4.786",
    transform: "translate(-53.542 -92.28)",
    fill: "#ffc39c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M66.967,111.353l1.026-1.961a.762.762,0,0,1,1.062-.306.9.9,0,0,1,.378.63l3.329-.216a.761.761,0,0,1,.36-.522.732.732,0,0,1,1.044.306l1.026,1.943a8.038,8.038,0,0,1-4.228,1.188,7.885,7.885,0,0,1-3.994-1.062",
    transform: "translate(-56.765 -92.28)",
    fill: "#fba889",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M55.043,42.989a6.865,6.865,0,0,1-6.855-6.855v-5.9a.825.825,0,0,1,.828-.828.8.8,0,0,1,.63.288c1.493-.666,6.244-2.447,10.994-.144a.866.866,0,0,1,.432-.126.826.826,0,0,1,.828.828v5.884a6.865,6.865,0,0,1-6.855,6.855",
    transform: "translate(-40.847 -24.079)",
    fill: "#ffc39c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M27.871,145.2H.828A.825.825,0,0,1,0,144.37v-7.629a8.474,8.474,0,0,1,8.457-8.475h1.6a.818.818,0,0,1,.648.324l3.634,4.822,3.635-4.822a.882.882,0,0,1,.666-.324h1.6a8.474,8.474,0,0,1,8.457,8.475v7.629a.837.837,0,0,1-.828.828",
    transform: "translate(0 -108.725)",
    fill: "#69b704",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M6.082,202.663H.828A.826.826,0,0,1,0,201.836V196.06H6.082Z",
    transform: "translate(0 -166.191)",
    fill: "#ffc39c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M153.616,202.663h-5.272v-6.6h6.1v5.776a.837.837,0,0,1-.828.828",
    transform: "translate(-125.745 -166.191)",
    fill: "#ffc39c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M37.785,193.053h-.936V185.19a.468.468,0,0,1,.936,0Z",
    transform: "translate(-31.235 -156.581)",
    fill: "#036d0c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M146.309,193.053h-.918V185.19a.459.459,0,1,1,.918,0Z",
    transform: "translate(-123.242 -156.581)",
    fill: "#036d0c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M44.432,10.688a.832.832,0,0,1-.792-.576,8.182,8.182,0,0,1,3.149-8.8A7.434,7.434,0,0,1,50.964,0a8.445,8.445,0,0,1,4.7,1.493,7.355,7.355,0,0,1,2.609,8.763.845.845,0,0,1-.918.45.861.861,0,0,1-.666-.756c-.27-3.887-3.8-4.354-5.074-4.354-2.735,0-6.334,1.835-6.352,4.264a.816.816,0,0,1-.7.81.307.307,0,0,1-.126.018",
    transform: "translate(-36.749 0)",
    fill: "#24313b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M64.4,69.566h1.336a.27.27,0,0,1,.27.27h0a.27.27,0,0,1-.27.27H64.4a.27.27,0,0,1-.27-.27h0a.27.27,0,0,1,.27-.27",
    transform: "translate(-54.362 -58.968)",
    fill: "#24313b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M110.229,69.566h1.336a.27.27,0,0,1,.27.27h0a.27.27,0,0,1-.27.27h-1.336a.27.27,0,0,1-.27-.27h0a.27.27,0,0,1,.27-.27",
    transform: "translate(-93.207 -58.968)",
    fill: "#24313b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M67.771,76.652h.006a.479.479,0,0,1,.45.5v.629a.479.479,0,0,1-.45.5h-.006a.479.479,0,0,1-.45-.5v-.629a.479.479,0,0,1,.45-.5",
    transform: "translate(-57.065 -64.975)",
    fill: "#24313b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M67.322,77.635v-.414a.449.449,0,0,1,.36-.45.231.231,0,0,1,.072.18v.45a.281.281,0,0,1-.27.288.22.22,0,0,1-.162-.054",
    transform: "translate(-57.066 -65.075)",
    fill: "#fefefe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M113.6,76.652h.006a.479.479,0,0,1,.45.5v.629a.479.479,0,0,1-.45.5H113.6a.479.479,0,0,1-.45-.5v-.629a.479.479,0,0,1,.45-.5",
    transform: "translate(-95.911 -64.975)",
    fill: "#24313b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M113.148,77.635v-.414a.448.448,0,0,1,.378-.45.32.32,0,0,1,.072.18v.45a.284.284,0,0,1-.288.288.29.29,0,0,1-.162-.054",
    transform: "translate(-95.911 -65.075)",
    fill: "#fefefe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M89.234,87.991h.887c.1,0,.18.121.18.27h0c0,.149-.081.27-.18.27h-.887c-.1,0-.18-.121-.18-.27h0c0-.149.081-.27.18-.27",
    transform: "translate(-75.487 -74.586)",
    fill: "#f77f6d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M84.326,101.073a.263.263,0,0,1,.342-.108.257.257,0,0,1,.09.342,2.08,2.08,0,0,1-.756.774,2,2,0,0,1-1.062.288,1.9,1.9,0,0,1-1.044-.288,2,2,0,0,1-.774-.774.263.263,0,0,1,.108-.342.242.242,0,0,1,.324.108,1.657,1.657,0,0,0,.576.594,1.607,1.607,0,0,0,.81.216,1.56,1.56,0,0,0,.81-.216,1.655,1.655,0,0,0,.576-.594",
    transform: "translate(-68.744 -85.563)",
    fill: "#f77f6d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    width: 6.1,
    height: 1.961,
    transform: "translate(22.599 29.869)",
    fill: "#036d0c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_197",
    "data-name": "Rectangle 197",
    width: 6.1,
    height: 1.961,
    transform: "translate(0 29.869)",
    fill: "#036d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M239.406,292.447c5.452,0,11.318-3.491,11.318-11.192V264.072a1.044,1.044,0,0,1,1.044-1.044h6.478a1.044,1.044,0,0,1,1.044,1.044v17.939c0,13.009-10.31,18.947-19.882,18.947Z",
    transform: "translate(-202.934 -222.957)",
    fill: "#1dce29",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M313.7,269.451v-5.38a1.044,1.044,0,0,1,1.044-1.044h6.477a1.044,1.044,0,0,1,1.044,1.044v5.38Z",
    transform: "translate(-265.906 -222.956)",
    fill: "#217f29",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M187.256,273.943a1.171,1.171,0,0,1-.468-.108,1.04,1.04,0,0,1-.54-1.17l1.979-8.133-5.722.216a1.026,1.026,0,0,1-.971-.594,1.047,1.047,0,0,1,.126-1.116L192.726,249.6a1.049,1.049,0,0,1,1.26-.27,1.028,1.028,0,0,1,.558,1.152l-1.817,8.565,5.326-.108a1.094,1.094,0,0,1,.954.594,1.078,1.078,0,0,1-.126,1.134l-10.814,12.919a1.064,1.064,0,0,1-.81.36",
    transform: "translate(-153.789 -211.255)",
    fill: "#ffc107",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M117.579,281.254V264.071a1.044,1.044,0,0,0-1.044-1.044h-6.478a1.044,1.044,0,0,0-1.044,1.044V282.01c0,13.009,10.31,18.947,19.864,18.947v-8.511c-5.434,0-11.3-3.491-11.3-11.192",
    transform: "translate(-92.406 -222.956)",
    fill: "#b4ef7f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M117.579,269.451v-5.38a1.044,1.044,0,0,0-1.044-1.044h-6.478a1.044,1.044,0,0,0-1.044,1.044v5.38Z",
    transform: "translate(-92.406 -222.956)",
    fill: "#439985",
    fillRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectDials);
export default __webpack_public_path__ + "static/media/direct-dials.d88566728ec167ed9a424b0a29a18ad2.svg";
export { ForwardRef as ReactComponent };